import * as RadixTooltip from "@radix-ui/react-tooltip";
import { Info } from "lucide-react";
import type { ReactNode } from "react";

export const TooltipProvider = ({
  children,
  delayDuration = 200,
}: {
  children: ReactNode;
  delayDuration?: number;
}) => (
  <RadixTooltip.Provider delayDuration={delayDuration} skipDelayDuration={200}>
    {children}
  </RadixTooltip.Provider>
);

const CONTENT_CLASSES =
  "z-50 max-w-xs rounded-md border border-border bg-card px-3 py-2 text-xs leading-snug text-text-primary shadow-md data-[state=delayed-open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=delayed-open]:fade-in-0";

export interface InfoTooltipProps {
  content: ReactNode;
  label: string;
  side?: "top" | "right" | "bottom" | "left";
  iconClassName?: string;
}

export function InfoTooltip({
  content,
  label,
  side = "top",
  iconClassName = "text-text-muted hover:text-text-secondary",
}: InfoTooltipProps) {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>
        <button
          type="button"
          aria-label={label}
          className={`inline-flex items-center justify-center rounded-full p-0.5 ${iconClassName}`}
        >
          <Info size={14} aria-hidden="true" />
        </button>
      </RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          side={side}
          sideOffset={6}
          collisionPadding={8}
          className={CONTENT_CLASSES}
        >
          {content}
          <RadixTooltip.Arrow className="fill-card" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
}
